import React, { createContext, useContext, useState } from "react";

const IneRegistrersContext = createContext();

export const IneRegistrersProvider = ({ children }) => {
  //Gestion del contenido de los Alert
  const [message, setMessage] = useState("Esto un mensaje de prueba");
  const [alertType, setAlertType] = useState("success");

  //Gestion del Alert del Header
  const [showAlertHeader, setShowAlertHeader] = useState(false);
  const openAlertHeader = () => {
    setShowAlertHeader(true);
  };
  const closeAlertHeader = () => {
    setShowAlertHeader(false);
  };

  const [apiSuccess, setApiSuccessSuccess] = useState(false);
  const changeApiSuccess = () => {
    setApiSuccessSuccess(!apiSuccess);
  };
  return (
    <IneRegistrersContext.Provider
      value={{
        apiSuccess,
        changeApiSuccess,
        alertType,
        setAlertType,
        setMessage,
        message,
        openAlertHeader,
        closeAlertHeader,
        showAlertHeader,
      }}
    >
      {children}
    </IneRegistrersContext.Provider>
  );
};

export const useIneRegistrers = () => {
  return useContext(IneRegistrersContext);
};
